var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_setup.quote_quoteKLine.loading),expression:"quote_quoteKLine.loading"}],ref:"refChat",attrs:{"id":"chart"}})
}
var staticRenderFns = []

export { render, staticRenderFns }